import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() total = 100;
  @Input() limit = 10;
  @Input() currentUrl;

  @Output() setPag = new EventEmitter();

  pags;

  constructor() {  }

  ngOnInit() {
  }

  ngOnChanges( changes: SimpleChanges ) {
    if(changes.total.currentValue) {
      this.updatePagination();
    }
  }

  sendPag(val) {
    this.setPag.emit(val);
  }

  updatePagination() {
    this.pags = [];

    for(let i = 0; i < Math.ceil(this.total/this.limit); i++) {
      this.pags.push(i+1);
    }
  }

}
